import AuthService from "@/services/AuthService";
import { router } from "../router";

const user = window.$cookies.get("user");
const state = user
  ? { status: { loggedIn: true, registering: false, updating: false }, user }
  : { status: { loggedIn: false }, user: null };

const actions = {
  login({ dispatch, commit }, { username, password }) {
    commit("loginRequest", { username });

    AuthService.login(username, password).then(
      user => {
        commit("loginSuccess", user);
        router.push("/");
      },
      error => {
        commit("loginFailure", error);
        dispatch("alert/error", error, { root: true });
      }
    );
  },
  logout({ commit }) {
    AuthService.logout();
    commit("logout");
    router.push("/login");
  },
  register({ dispatch, commit }, user) {
    commit("registerRequest", user);

    AuthService.register(user).then(
      user => {
        commit("registerSuccess", user);
        dispatch(
          "alert/success",
          "The registration was successful." +
          (user.apiKey ? "\n ApiKey: " + user.apiKey : ""),
          { root: true }
        );
      },
      error => {
        commit("registerFailure", error);
        dispatch("alert/error", error, { root: true });
      }
    );
  },
  update({ dispatch, commit }, user) {
    commit("updateRequest", user);

    AuthService.update(user).then(
      user => {
        commit("updateSuccess", user);
        dispatch("alert/success", "The update was successful.", {
          root: true
        });
      },
      error => {
        commit("updateFailure", error);
        dispatch("alert/error", error, { root: true });
      }
    );
  }
};

const getters = {
  isUserLoggedIn: state => {
    return state.status && state.status.loggedIn;
  },
  isAdmin: state => {
    return (
      state.status &&
      state.status.loggedIn &&
      state.user &&
      state.user._doc.role === 'admin'
    );
  },
  isEditor: state => {
    return (
      state.status &&
      state.status.loggedIn &&
      state.user &&
      state.user._doc.role === 'editor'
    );
  },
  displayName: state => {
    if (!state.status.loggedIn) {
      return undefined
    }
    const u = state.user._doc
    return u.username + ' (' + u.role + ')'
  }
};

const mutations = {
  loginRequest(state, user) {
    state.status = { loggingIn: true };
    state.user = user;
  },
  loginSuccess(state, user) {
    state.status = { loggedIn: true, registering: false, updating: false };
    state.user = user;
  },
  loginFailure(state) {
    state.status = { isLoggedIn: false };
    state.user = null;
  },
  logout(state) {
    state.status = { isLoggedIn: false };
    state.user = null;
  },
  registerRequest(state) {
    state.status.registering = true;
  },
  registerSuccess(state) {
    state.status.registering = false;
  },
  registerFailure(state) {
    state.status.registering = false;
  },
  updateRequest(state) {
    state.status.updating = true;
  },
  updateSuccess(state) {
    state.status.updating = false;
  },
  updateFailure(state) {
    state.status.updating = false;
  }
};

export const account = {
  namespaced: true,
  state,
  actions,
  mutations,
  getters
};
